import React from 'react';
import classes from './PageLoading.module.scss';

const PageLoading = () => (
  <div className={classes.pageLoading}>
    <div className={classes.brandName}>SensoryOne</div>
    <div className={classes.spinner} />
  </div>
);

export default PageLoading;
